import classNames from 'classnames';
import { FC } from 'react';

import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { useMobileAppsListPresenter } from './MobileAppsList.presenter';
import styles from './MobileAppsList.styles.m.css';
import { IMobileAppsListProps } from './MobileAppsList.types';

export const MobileAppsList: FC<IMobileAppsListProps> = (props) => {
  const { apps, className, buttonsTheme = 'outline' } = props;
  const presenter = useMobileAppsListPresenter({ apps });
  const containerClassName = classNames(styles.container, className);

  return (
    <ul className={containerClassName}>
      {presenter.appsItems.map((app) => (
        <li
          key={app.url}
          className={classNames(styles.appItem, styles[`app-${app.name}`])}
        >
          <IconButton
            theme={buttonsTheme}
            size={IconViewSizes.Big}
            iconSize={IconViewSizes.Medium}
            Icon={app.Icon}
            iconClassName={styles.appIcon}
            className={styles.appButton}
            onClick={(): void => presenter.onAppClick(app.url)}
          />
        </li>
      ))}
    </ul>
  );
};
